import { loadForeignFlowByTicker } from '../services/duckdbService';
import { api } from '../services/api';

/**
 * Fetch foreign flow data directly from Azure Blob Storage (parquet) instead of passing
 * through the backend API.
 */
export async function fetchForeignFlowDataDirect(ticker: string, limit?: number) {
  try {
    const tokenRes = await api.getBrokerSummarySasToken();
    if (!tokenRes.success || !tokenRes.data) {
      throw new Error(tokenRes.error || 'Failed to get SAS token');
    }
    const { containerUrl, sasToken } = tokenRes.data;
    
    const rows = await loadForeignFlowByTicker(ticker, containerUrl, sasToken);
    
    // Sort chronological ascending
    const sorted = [...rows].sort((a, b) => {
      const da = new Date(a.Date || a.date || '').getTime();
      const db = new Date(b.Date || b.date || '').getTime();
      return da - db;
    });

    let resultData = sorted;
    if (limit && limit > 0) {
      resultData = sorted.slice(-limit);
    }

    return {
      success: true,
      data: {
        code: ticker.toUpperCase(),
        data: resultData,
        total: resultData.length
      }
    };
  } catch (err: any) {
    console.error(`Error loading foreign flow for ${ticker} directly:`, err);
    return {
      success: false,
      error: err.message || 'Failed to load foreign flow'
    };
  }
}
